document.addEventListener("turbolinks:load", () => {
  const tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
  tooltipTriggerList.map((tooltipTriggerEl) => (
    new bootstrap.Tooltip(tooltipTriggerEl)
  ))
})
